export default "__VITE_ASSET__Ccp7LssS__"